<template>
	<div class="" @click="$sidebar.displaySidebar(false)">			
		<div class="row ">
            <div class="col-xl-8 mb-5 mb-xl-0">
                <div class="card shadow">
                    <div class="card-body">	
 						<h4 class="mb-3 card-ttl">ロール管理<a class="btn btn-primary float-right" href="/roles/create"  v-show="permission_list['role-create']? true:false">ロール登録</a></h4>	
						<div class="loading"  v-show="loading">受信中...</div>
						<div class="el-table__body-wrapper table-responsive">
							<table class='table table-striped el-table__body' v-if="!loading">
								<thead>
									<tr class="el-table__row">
										<th scope="col">ID</th>
										<th scope="col">ロール名</th>
										
										<th scope="col">&nbsp;</th>
									
									</tr>
								</thead>
								<tbody>
									<tr  v-for="role in roleListData.data" :key="role.id" class="el-table__row">
										<td class="el-table_1_column_1"> {{ role.id }} </td>
										<td class="el-table_1_column_2" max-width="150px"> {{ role.name }} </td>
										
										<td class="el-table_1_column_5">
											<div class="btn-wrap form-group text-center">
											<a class="btn btn-primary" :href="'/roles/'+ role.id">詳細</a>
       										<a class="btn btn-primary" :href="'/roles/'+ role.id + '/edit'" v-show="role.edit_disable ? false: permission_list['role-edit']? true:false">編集</a>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>	
					</div>
                </div>
            </div>
			<div class="pagination-wrap">
			<pagination align="center" :data="roleListData" :show-disabled="true" :limit=5  @pagination-change-page="getResults">
				<span slot="prev-nav">&lt;</span>
				<span slot="next-nav">&gt;</span>
			</pagination>
			</div>
		</div>
	</div>
</template>

<script>
import pagination from 'laravel-vue-pagination'

export default {
	components: { pagination},
	props: ['RoleList'],
	data() {
		return {
			// Our data object that holds the Laravel paginator data
			roleListData: {},
			lastpage: null,
			siteId:null
			
		}
	},

	mounted() {
		// Fetch initial results
		this.siteId = window.PushL.site_id;
		console.log(this.siteId )
		console.log("aaaaaa")
		this.roleListData = JSON.parse(this.RoleList)
		this.lastpage = this.roleListData.last_page
	},

	methods: {
		// Our method to GET results from a Laravel endpoint
		getResults(page = 1) {
			if(this.lastpage != null && this.lastpage < page) return;
			console.log("wwwwwwwwww")
			axios.get('/roles?page=' + page)
				.then(response => {
					this.roleListData = response.data;
					this.lastpage = response.data.last_page
				});
		},
	}

}
</script>

<style scoped>
.btn {
	word-break:keep-all;
}
</style>